<div class="modal-header">
  <!-- <h3 class="modal-title"></h3> -->
  <button type="button" class="close text-primary" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <i class="fas fa-times-circle"></i>
  </button>
</div>
<div class="modal-body scroll-dark-active activity">
  <form [formGroup]="assigmentForm" (ngSubmit)="add()">
    <div class="form-group">
      <h4 class="form-section "><i class="fas fa-user-tag ml-1"></i> Asignar Usuario</h4>
    </div>
    <div class="form-group">
      <label class="text-form">Usuarios</label>
      <ng-select formControlName="idsUsers" [items]="mappedUsers"  bindLabel="texto"
        placeholder="Seleccione Usuario" [(ngModel)]="multipleMultiSelect"
        class="form-control px-0 py-0 collaborators"
        [ngClass]="{ 'is-invalid':assigmentForm.controls.idsUsers.touched }">
      </ng-select>
    </div>
    <div class="line_horizontal_container">
      <div class="line_horizontal"></div>
    </div>
    <div class="form-group mt-3">
      <div class="row">
        <div class="col-md-12 text-right">
          <button type="button" class="btn btn-outline-dark rounded-pill font-weight-bold" style="width: 120px;"
            (click)="activeModal.close('Close click')">
            Cerrar
          </button>
          <button type="submit" class="btn btn-outline-primary  rounded-pill font-weight-bold mr-2"
            style="width: 120px;" [disabled]="!submitted">
            @if (submitted && assigmentForm.valid) {
              <div>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Cargando...
              </div>
            }
            @if (!submitted) {
              <span>
                Guardar
              </span>
            }
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
